<template>
  <w-icon-wrapper
    :height='15'
    :width='24'
    icon-name='work-view-icon'
    view-box='0 0 24 15'
  >
    <g
      id='_58_Ansicht_Icon'
      data-name='58 Ansicht_Icon'
      transform='translate(0.25 -4.25)'
    >
      <path
        id='Pfad_55766'
        d='M22.43,9.573A13.251,13.251,0,0,0,11.75,4.25,13.251,13.251,0,0,0,1.07,9.573,12.242,12.242,0,0,0-.25,11.75a12.242,12.242,0,0,0,1.32,2.177A13.251,13.251,0,0,0,11.75,19.25a13.251,13.251,0,0,0,10.68-5.323,12.242,12.242,0,0,0,1.32-2.177A12.242,12.242,0,0,0,22.43,9.573Zm-10.68,7.7A11.218,11.218,0,0,1,2.034,11.75a11.31,11.31,0,0,1,19.432,0A11.218,11.218,0,0,1,11.75,17.271Z'
        data-name='Pfad 55766'
        fill='currentColor'
      />
      <path
        id='Pfad_55767'
        d='M11.75,7.3a4.453,4.453,0,1,0,4.5,4.453A4.477,4.477,0,0,0,11.75,7.3Zm0,6.927a2.474,2.474,0,1,1,2.5-2.474A2.49,2.49,0,0,1,11.75,14.224Z'
        data-name='Pfad 55767'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconView' };
</script>
